import React from 'react';
import clsx from 'clsx';

interface SectionHeaderProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ eyebrow, title, description, actions, className }) => (
  <div className={clsx('ui-section-head', className)}>
    <div className="ui-section-head__copy">
      {eyebrow && <div className="ui-section-head__eyebrow">{eyebrow}</div>}
      <h2 className="ui-section-head__title">{title}</h2>
      {description && <p className="ui-section-head__desc">{description}</p>}
    </div>
    {actions && <div className="ui-section-head__actions">{actions}</div>}
  </div>
);
